module.exports = __webpack_public_path__ + "data_manager.b76b6f4b7b87fff7a6c7e3256c06ed00.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/data_manager.svg
// module id = 353
// module chunks = 0